import styled from 'src/lib/styles/css';

//#region [Props]
type ChartItemPremiereProps = {
	premiere?: string | null;
};
//#endregion

//#region [Component]
export default function ChartItemPremiere({ premiere }: ChartItemPremiereProps) {
	let date;

	if (premiere) {
		date = premiere.substring(8, 10) + "." + premiere.substring(5, 7) + "." + premiere.substring(0, 4);
		if (date === "01.01.0001") date = "Ukjent";

		return (
			<div>
				<SDetailHeader>Premiere: </SDetailHeader>
				<span>{date}</span>
			</div>
		);
	}

	return null;
}
//#endregion

//#region [Styles]
const SDetailHeader = styled.span`
	font-weight: bold;
`;
//#endregion